module.exports = __webpack_public_path__ + "static/media/icomoon.67a3bc28.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/icomoon/icomoon.eot?24fgiz
// module id = 2938
// module chunks = 0